import { useState, useEffect } from 'react';
import { Platform } from 'react-native';
import { getValue , fetchAndActivate } from 'firebase/remote-config';
import { firebaseInit } from '../../utils';



const useSingleRemoteConfig = (configId: string) => {
  const [configValue, setConfigValue] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        setLoading(true);
        setError(null);

        let data;

        if (Platform.OS === 'web') {
          const remoteConfig = firebaseInit();
          await fetchAndActivate(remoteConfig);
          data = getValue(remoteConfig, configId);
        } else {
          //mobile handling here
          const { default: remoteConfig } = await import('@react-native-firebase/remote-config');
          await remoteConfig().fetchAndActivate();
          data = remoteConfig().getValue(configId);
        }

        // Process the fetched data
        setConfigValue(data?.asString() ?? null);

      } catch (err: any) {
        console.error(err);
        setError(err.message || 'Unknown error');
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, [configId]);

  return { configValue, loading, error };
};

export default useSingleRemoteConfig;
